import { Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { DEFENDER } from '@sq/shared';
import { useQuest } from '../lib/store.tsx';
import { loadRun, resumeLabel } from '../lib/run.ts';
import { Motif } from '../components/Motif.tsx';
import { TopBar, Footer } from '../components/TopBar.tsx';

/** Event QR lands here: one tap on START puts the player in Round 1. */
export default function Landing() {
  const { quest, event, eventSlug } = useQuest();
  const nav = useNavigate();
  const [saved] = useState(() => loadRun(eventSlug));
  useEffect(() => {
    document.title = `${event.defenderTitle} · Docker`;
  }, [event.defenderTitle]);

  // Already finished (and no new run in progress): straight to the reward.
  if (quest.completed && !saved) return <Navigate to="/reward" replace />;

  const start = () => nav('/play', { state: { intent: 'start' } });
  return (
    <div className="app">
      <TopBar />
      <main className="page landing">
        <section className="hero">
          <Motif />
          <p className="eyebrow">
            {event.title} · {event.defenderTitle}
          </p>
          <h1 className="h1">
            Trust Docker for <em>the agents you don't</em>
          </h1>
          <p className="lede">
            Your job: build as fast as possible.
          </p>
          <p className="lede">
            Unlock your agent, but reduce the risks.
          </p>
          <p className="lede">
            Explore the possibilities while keeping control.
          </p>
        </section>

        {saved ? (
          <div className="cta-stack">
            <button className="btn primary big block" data-testid="resume-run" onClick={() => nav('/play', { state: { intent: 'resume' } })}>
              {resumeLabel(saved)} →
            </button>
            <button className="btn ghost block" data-testid="start-over" onClick={start}>
              Start over
            </button>
          </div>
        ) : (
          <button className="btn primary big block start-btn" data-testid="start" onClick={start}>
            START
          </button>
        )}

        <p className="muted small-print">
          <b>Privacy:</b>{' '}
          {event.privacyNote ||
            'No names, emails, or sign-in. We keep an anonymous browser token and coarse game stats for this event only, deleted after 30 days.'}
        </p>
      </main>
      <Footer />
    </div>
  );
}
